import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SbkBillersDataService {
    private beneficiariesServicePath = '/contact-manager';
    private servicePath = '/omni-integration-service';
    private apiRoot = '/api';

    constructor(private readonly http: HttpClient) { }

    getBillers(): Observable<any> {
        const uri = `${this.apiRoot}/contentservices/client-api/contentstream/portalRepository/custom/omni-billers`;
        return this.http.get(uri);
    }

    getBillerBeneficiaries(): Observable<any> {
        const version = 'v2';
        const uri = `${this.apiRoot}${this.beneficiariesServicePath}/client-api/${version}/contacts?from=0&size=50`;

        return this.http.get(uri);
    }

    getPendingBills(payload: any): Observable<any> {
        const version = 'v1';
        const uri = `${this.apiRoot}${this.servicePath}/client-api/${version}/bill-presentment`;

        return this.http.post(uri, payload);
    }

    deleteBiller(billerId: string): Observable<any> {
        const version = 'v2';
        const uri = `${this.apiRoot}${this.beneficiariesServicePath}/client-api/${version}/contacts/${billerId}`;

        return this.http.delete(uri);
    }

    updateBiller(billerId: string, payload: any): Observable<any> {
        const version = 'v2';
        const uri = `${this.apiRoot}${this.beneficiariesServicePath}/client-api/${version}/contacts/${billerId}`;

        return this.http.put(uri, payload);
    }
}
